<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery"> </a-form>
    </div>
    <!-- 查询区域-END -->
    <!-- table区域-begin -->
    <div class="table-operator-button">
      <a-button @click="searchQuery" type="primary">刷新</a-button>
      <a-button
        style="margin-left: 10px"
        v-if="dataSource.length > 0 && projectRecords[0].manager == userInfo.username"
        @click="cancelChangeUser"
        type="primary"
        >取消本次调整</a-button
      >
      <a-button
        style="margin-left: 10px"
        v-else-if="dataSource.length > 0"
        v-has="'DailyProject:admin'"
        @click="cancelChangeUser"
        type="primary"
        >取消本次调整</a-button
      >

      <!-- <a-button style="margin-left:10px" v-if="(dataSource.length>0)&&(projectRecords[0].manager ==userInfo.username)" @click="userInNow" type="primary">立即生效</a-button> -->
    </div>
    <a-alert class="margin-top-20px" :message="infoMessage" type="info" show-icon />
    <div>
      <a-table
        class="margin-top-20px"
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
      </a-table>
    </div>

    <busDailyProjectUserNext-modal ref="modalForm" @ok="modalFormOk"></busDailyProjectUserNext-modal>
  </a-card>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getAction } from '@/api/manage'
import { deleteProjectUserNextByProjectId, addBusDailyProjectUser } from '@/api/api'
import BusDailyProjectUserNextModal from './modules/BusDailyProjectUserNextModal'
import { USER_INFO } from '@/store/mutation-types'
import Vue from 'vue'
export default {
  name: 'BusDailyProjectUserNextList',
  mixins: [JeecgListMixin],
  components: {
    BusDailyProjectUserNextModal,
  },
  mounted() {
    this.$nextTick(() => {
      this.userInfo = Vue.ls.get(USER_INFO)
    })
  },
  props: {
    projectRecords: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      infoMessage: '以下内容尚未生效，需等到次日才生效',
      description: '项目成员待生效列表管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '项目名称',
          align: 'center',
          dataIndex: 'projectName',
        },
        {
          title: '项目成员',
          align: 'center',
          dataIndex: 'members',
        },

        {
          title: '所属角色',
          align: 'center',
          dataIndex: 'subordinateRoleText',
        },
        {
          title: '工作量占比',
          align: 'center',
          dataIndex: 'workload',
        },
      ],
      url: {
        list: '/dailyproject/busDailyProjectUserNext/selectProjectUserNext',
        delete: '/dailyproject/busDailyProjectUserNext/delete',
        deleteBatch: '/dailyproject/busDailyProjectUserNext/deleteBatch',
        exportXlsUrl: '/dailyproject/busDailyProjectUserNext/exportXls',
        importExcelUrl: 'dailyproject/busDailyProjectUserNext/importExcel',
      },
      dictOptions: {},
      ipagination: {
        current: 1,
        pageSize: 999,
        pageSizeOptions: ['999'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: false,
        showSizeChanger: false,
        total: 0,
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initData() {
      this.loadData()
    },
    loadData() {
      //加载数据 若传入参数1则加载第一页的内容
      if (!this.projectRecords[0].id) {
        this.$message.error('projectRecords没有传值')
        return
      }
      this.loading = true
      this.dataSource = []
      getAction(this.url.list, { projectId: this.projectRecords[0].id }).then((res) => {
        if (res.success) {
          this.dataSource = res.result
        } else {
          this.$message.warning(res.message)
        }
        if (res.code === 510) {
          this.$message.warning(res.message)
        }
        this.loading = false
      })
    },
    cancelChangeUser() {
      if (!this.projectRecords[0].id) {
        this.$message.error('projectRecords没有传值')
        return
      }
      this.$antdConfirm({
        title: '取消本次调整',
        content: '取消本次调整，本次修改内容次日不会生效，依旧使用原来方案，确定吗？',
        onOk: () => {
          deleteProjectUserNextByProjectId({ projectId: this.projectRecords[0].id })
            .then((res) => {
              if (res.success) {
                this.loadData(1)
              } else {
                this.$message.error(res.message)
              }
            })
            .catch((err) => {
              this.$message.error(err.message)
            })
        },
      })
    },
    userInNow() {
      this.$antdConfirm({
        title: '立刻生效',
        content: '将会立刻生效，确定吗？',
        onOk: () => {
          addBusDailyProjectUser()
            .then((res) => {
              if (res.success) {
                this.loadData(1)
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch((err) => {
              this.$message.error(err.message)
            })
        },
      })
    },
  },
  watch: {
    projectRecords: {
      handler() {
        this.loadData(1)
      },
      immediate: true,
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
